import React from 'react';
import { observer } from 'mobx-react-lite';
import {
    SelectNativeWrapper,
    SelectElement,
    ChevronDownWrapper,
    SelectNativeWrapperInner,
} from 'src/domains/layouts/shared/formComponents/Select/SelectNative.style';
import { InputError } from 'src/domains/layouts/shared/formComponents/FormComponents.style';

interface SelectNativePropsType {
    className?: string;
    value: string | number | undefined;
    error?: string;
    children: React.ReactNode;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    onClick?: () => void;
    version?: 'primary' | 'secondary';
    dataTest?: string;
}

export const SelectNative = observer(
    ({ className, error, value, children, onChange, onClick, version, dataTest }: SelectNativePropsType) => {
        return (
            <SelectNativeWrapper>
                <SelectNativeWrapperInner className={className}>
                    <SelectElement
                        onChange={onChange}
                        value={value}
                        data-test={dataTest}
                        version={version}
                        onClick={onClick}
                    >
                        {children}
                    </SelectElement>

                    <ChevronDownWrapper />
                </SelectNativeWrapperInner>
                {error === undefined ? null : <InputError>{error}</InputError>}
            </SelectNativeWrapper>
        );
    }
);
